<div class="agent-chat-container" [ngClass]="{
  'new-chat-mode': isNewAgentChat,
  'active-chat-mode': !isNewAgentChat,
  'with-source-panel': isSourcePanelVisible && agentId === 'regulations_agent'
}">

  <!-- Agent Header with Dropdown (always shown when agent is selected) -->
  <app-agent-header 
  [agentId]="agentId" 
  [isSidebarOpen]="isSidebarOpen"
  [isNewChat]="isNewAgentChat"
    [isSourcePanelVisible]="isSourcePanelVisible && agentId === 'regulations_agent'"
    (newChatRequested)="onAgentNewChat()" 
    (sessionSelected)="onSessionSelected($event)"
    (aboutRequested)="onAgentAbout()">
  </app-agent-header>
  <div class="agent-chat-container-wrapper" [ngClass]="{'with-source-panel': isSourcePanelVisible && agentId === 'regulations_agent'}">
    <div class="agent-chat-main" [ngClass] = "{
      'prompt-pills-visible': promptPills && promptPills.length > 0 && showBubblesForCurrentAgent,
      'scroll-arrow-visible': showScrollToBottomArrow
    }">
      <!-- Session Loading (same as chatbot: overlay + app-loading + text) -->
      <div *ngIf="isLoadingSession" class="session-loading-overlay">
        <div class="session-loading-container">
          <app-loading></app-loading>
          <span class="session-loading-text">{{ 'LOADING_SESSION_TEXT' | translate }}</span>
        </div>
      </div>

      <!-- Landing Page (shown when new chat) -->
      <div class="agent-landing-wrapper" *ngIf="isNewAgentChat">
        <app-agent-landing 
        [agentId]="agentId" 
        [userFName]="userFName"
         (promptSelected)="onPromptSelected($event)">
        </app-agent-landing>
      </div>

      <!-- Chat History (shown when not new chat) -->
      <div class="agent-chat-history-wrapper" #chatHistoryWrapper *ngIf="!isNewAgentChat" [ngClass]="{ 'sidebar-open': isSidebarOpen }">
        <app-agent-chat-interface 
        #agentChatInterface 
        [ChatQueriesList]="ChatQueriesList" 
        [agentId]="agentId"
        [tenantId]="chatbotComponentRef?.tenantID ?? ''"
        [configdata]="metadataConfigData"
        [metadataModuleName]="metadataModuleName"
        [feedbackOptionsConfig]="feedbackOptionsFromConfig"
        [loaderShow]="internalLoaderShow"
        [isResponseStreaming]="isResponseStreaming"
        [isConversationSaved]="isConversationSaved"
        [isFollowUpQuestionsReceived]="isFollowUpQuestionsReceived"
        [IsNewChat]="isNewAgentChat"
        [isLoadingMoreHistory]="isLoadingMoreHistory"
        [hasMoreHistory]="hasMoreHistoryPages"
        [showReasoning]="showReasoning"
        [reasoningSteps]="reasoningSteps"
        [activeReasoningIndex]="activeReasoningIndex"
        [showEngagingLoader]="showEngagingLoader"
        [engagingLoaderIsStreaming]="engagingLoaderIsStreaming"
        [engagingLoaderIsCompleted]="engagingLoaderIsCompleted"
        [engagingLoaderSteps]="engagingLoaderSteps"
        [engagingLoaderCurrentAction]="engagingLoaderCurrentAction"
        [isMetadataLoading]="isMetadataLoading"
        [isBubblesLoading]="isBubblesLoading"
        [animateLastMessage]="animateLastMessage"
        (scrollArrowChange)="onScrollArrowChange($event)"
        (userScrolledUp)="onUserScrolledUp()"
        (pillClicked)="onPillClick($event)"
        (loadMoreHistory)="onLoadMoreHistory()"
        (ChatQueriesListEmit)="onChatQueriesListEmit($event)"
        (showSharePopup)="onShowSharePopup($event)"
        (hideSharePopup)="onHideSharePopup()"
        (responseOptionsMenuAction)="onResponseOptionsMenuAction($event)"
        (feedbackLikeClick)="onFeedbackLikeClick($event)"
        (feedbackDislikeUndo)="onFeedbackDislikeUndo($event)"
        (feedbackSubmit)="onFeedbackSubmit($event)"
        (metadataCloseHistory)="onMetadataCloseHistory()"
        (metadataDisplaySourcePanel)="onMetadataDisplaySourcePanel($event)"
        (tableDownloaded)="onTableDownloaded($event)"
        (tableDownloadFailed)="onTableDownloadFailed()"
        (filePreviewRequested)="onFilePreviewRequested($event)"
        (filePreviewFailed)="onFilePreviewFailed($event)"
        (fileDownloadCompleted)="onFileDownloadCompleted($event)"
        (fileDownloadFailed)="onFileDownloadFailed($event)">
      </app-agent-chat-interface>

      <div class="agent-pills-above-prompt" *ngIf="!isNewAgentChat && promptPills && promptPills.length > 0 && showBubblesForCurrentAgent">
        <app-agent-pills
          [pills]="promptPills"
          [isDisabled]="internalLoaderShow || !streamFullyComplete"
           [idPrefix]="'prompt_pill'"
            (pillClicked)="onPillClick($event)">
          </app-agent-pills>
        </div>
      </div>

      <!-- Prompt Section (moves to bottom when chat starts) - Only shown when agent config is available -->
      <div class="agent-prompt-wrapper position-relative" *ngIf="hasAgentConfig" [ngClass]="{
      'prompt-landing': isNewAgentChat,
      'prompt-collapsed': !isNewAgentChat,
      'sidebar-open': isSidebarOpen && !isNewAgentChat,
      'with-source-panel': isSourcePanelVisible && agentId === 'regulations_agent' && !isNewAgentChat
    }">

        <!-- Scroll to Bottom Arrow (positioned above prompt, like chatbot) -->
        <div class="scroll-to-bottom-arrow" 
        *ngIf="showScrollToBottomArrow" 
        (click)="scrollToBottomClick()"
        (keydown.enter)="scrollToBottomClick()"
        (keydown.space)="scrollToBottomClick()">
          <button class="scroll-arrow-btn" type="button"  [attr.data-scroll-to-latest]="'SCROLL_TO_LATEST' | translate">
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 5V19M12 19L6 13M12 19L18 13" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
        </div>


        <app-prompt-section 
        [agentId]="agentId"
         [loaderShow]="internalLoaderShow"
          [isNewChat]="isNewAgentChat"
          [vectorDbDatasets]="promptLibraryVectorDbDatasets"
          [selectedVectorDbDataset]="promptLibrarySelectedVectorDbDataset"
          [IsResponseStreaming]="engagingLoaderIsStreaming" 
          [domainName]="promptLibraryDomainName"
          [tenantId]="promptLibraryTenantId"
           [userId]="promptLibraryUserId"
          [allDomainNames]="promptSectionAllDomainNames"
          [isDomainManagementEnabled]="promptSectionIsDomainManagementEnabled" 
          (sendRequest)="onSendRequest($event)"
          (promptLibraryNewSelectedDataset)="onPromptLibraryNewSelectedDataset($event)"
          (promptLibraryClickNewChat)="onAgentNewChat()" 
          (promptLibraryScrollBottom)="scrollToBottomClick()"
          (suggestionSelected)="onPromptSectionSuggestionSelected($event)"
          (domainInserted)="onPromptSectionDomainInserted()">
        </app-prompt-section>
      </div>

      <!-- Disclaimer fixed below text area (does not scroll with content) -->
      <div class="agent-disclaimer-fixed" [ngClass]="{
      'sidebar-open': isSidebarOpen,
      'isNewAgentChat': isNewAgentChat,
      'with-source-panel': isSourcePanelVisible && agentId === 'regulations_agent'
    }">
       <span>  {{ 'DISCLAIMER_TEXT' | translate }} </span>
      </div>
    </div>

    <!-- Source Panel Column (regulation agent – view all sources) -->
    <div *ngIf="isSourcePanelVisible && agentId === 'regulations_agent'" class="source-panel-column">
      <app-agent-source-panel-wrapper
       [sourceContext]="currentSourceData" 
       [configdata]="sourcePanelConfigData"
        [tenantId]="sourcePanelTenantId"
         [domainId]="sourcePanelDomainId"
          (closePanelEvent)="closeSourcePanel()">
      </app-agent-source-panel-wrapper>
    </div>
  </div>
</div>

<!-- Success toast for table download -->
<div *ngIf="tableDownloadSuccessVisible" class="toast success agent-feedback-toast" id="agent_table_download_success_toast">
  <div class="agent-feedback-toast-content">
    <img src="../../../../assets/images/newchat/correct.svg" width="18" alt="Success">
    <span>{{ 'TABLE_DOWNLOAD_SUCCESS_MESSAGE' | translate: { table_name: tableDownloadSuccessFileName } }}</span>
  </div>
  <a title="{{ 'CLOSE_TITLE_TEXT' | translate }}" href="javascript:void(0)" (click)="closeTableDownloadSuccess()"
    id="agent_table_download_success_close">
    <i class="icon-close1"></i>
  </a>
</div>

<!-- Error toast for table download -->
<div *ngIf="tableDownloadErrorVisible" class="toast error agent-feedback-toast" id="agent_table_download_error_toast">
  <div>
    <p class="toast-icon" id="agent_table_download_error_text">
      <img src="../../../../assets/images/newchat/exclamation.svg" width="18" alt="Error">
      {{ 'TABLE_DOWNLOAD_ERROR_MESSAGE' | translate }}
      <a title="{{ 'CLOSE_TITLE_TEXT' | translate }}" href="javascript:void(0)" (click)="closeTableDownloadError()"
        id="agent_table_download_error_close">
        <i class="icon-close1"></i>
      </a>
    </p>
  </div>
</div>

<!-- Success toast for feedback (outside scrollable container, positioned via :host) -->
<div *ngIf="feedbackSuccessVisible" class="toast success agent-feedback-toast" id="agent_feedback_success_toast">
  <div class="agent-feedback-toast-content">
    <img src="../../../../assets/images/newchat/correct.svg" width="18" alt="Success">
    <span>{{'EVOLVE_TOASTER_MESSAGE' | translate}}</span>
  </div>
  <a title="{{ 'CLOSE_TITLE_TEXT' | translate }}" href="javascript:void(0)" (click)="closeFeedbackSuccess()"
    id="agent_feedback_success_close">
    <i class="icon-close1"></i>
  </a>
</div>

<!-- Error toast for feedback (outside scrollable container, positioned via :host) -->
<div *ngIf="feedbackErrorVisible" class="toast error agent-feedback-toast" id="agent_feedback_error_toast">
  <div>
    <p class="toast-icon" id="agent_feedback_error_text">
      <img src="../../../../assets/images/newchat/exclamation.svg" width="18" alt="Expand">
      {{ feedbackErrorText }}
      <a title="{{ 'CLOSE_TITLE_TEXT' | translate }}" href="javascript:void(0)" (click)="closeFeedbackError()"
        id="agent_feedback_error_close">
        <i class="icon-close1"></i>
      </a>
    </p>
  </div>
</div>

<!-- Success toast for file attachment download -->
<div *ngIf="fileDownloadSuccessVisible" class="toast success agent-feedback-toast" id="agent_file_download_success_toast">
  <div class="agent-feedback-toast-content">
    <img src="../../../../assets/images/newchat/correct.svg" width="18" alt="Success">
    <span>{{ 'FILE_ATTACHMENT_DOWNLOAD_SUCCESS_MESSAGE' | translate: { file_name: fileDownloadSuccessFileName } }}</span>
  </div>
  <a title="{{ 'CLOSE_TITLE_TEXT' | translate }}" href="javascript:void(0)" (click)="closeFileDownloadSuccess()"
    id="agent_file_download_success_close">
    <i class="icon-close1"></i>
  </a>
</div>

<!-- Error toast for file attachment download -->
<div *ngIf="fileDownloadErrorVisible" class="toast error agent-feedback-toast" id="agent_file_download_error_toast">
  <div>
    <p class="toast-icon" id="agent_file_download_error_text">
      <img src="../../../../assets/images/newchat/exclamation.svg" width="18" alt="Error">
      {{ 'FILE_ATTACHMENT_DOWNLOAD_ERROR_MESSAGE' | translate: { file_name: fileDownloadErrorFileName } }}
      <a title="{{ 'CLOSE_TITLE_TEXT' | translate }}" href="javascript:void(0)" (click)="closeFileDownloadError()"
        id="agent_file_download_error_close">
        <i class="icon-close1"></i>
      </a>
    </p>
  </div>
</div>

<!-- Error toast for file attachment preview -->
<div *ngIf="filePreviewErrorVisible" class="toast error agent-feedback-toast" id="agent_file_preview_error_toast">
  <div>
    <p class="toast-icon" id="agent_file_preview_error_text">
      <img src="../../../../assets/images/newchat/exclamation.svg" width="18" alt="Error">
      {{ 'FILE_ATTACHMENT_PREVIEW_ERROR_MESSAGE' | translate: { file_name: filePreviewErrorFileName } }}
      <a title="{{ 'CLOSE_TITLE_TEXT' | translate }}" href="javascript:void(0)" (click)="closeFilePreviewError()"
        id="agent_file_preview_error_close">
        <i class="icon-close1"></i>
      </a>
    </p>
  </div>
</div>

<app-agent-document-preview-modal
  [isOpen]="isDocumentPreviewOpen"
  [previewRequest]="documentPreviewRequest"
  (closed)="onDocumentPreviewClosed()"
  (downloadCompleted)="onFileDownloadCompleted($event)"
  (downloadFailed)="onFileDownloadFailed($event)"
></app-agent-document-preview-modal>

<!-- Share Conversation Popup – same structure and styles as chatbot -->
<div class="popup-backdrop" *ngIf="sharePopupData" tabindex="-1" (click)="$event.stopPropagation()" (keydown)="onSharePopupKeydown($event)">
  <div class="popup">
    <div class="popup-header">
      <h1>{{ 'SHARE_LINK_POPUP_HEADING' | translate }} <button type="button" class="close-button" (click)="closeSharePopup()">
          <img src="../../../assets/icons/close.svg" alt="Close">
        </button></h1>
    </div>
    <div class="popup-body">
      <p class="popup-subtitle">{{ 'SHARE_LINK_POPUP_DESCRIPTION' | translate }}</p>
      <div class="form-button">
        <input type="text"
          [value]="sharePopupData.share_link || (sharePopupData.placeholder ? ('SHARE_LINK_PLACEHOLDER_AGENT' | translate) : '')"
          readonly 
          class="share-link-input" 
          style="background-color: #f5f5f5; cursor: default;">
        <button type="button" 
        (click)="copyShareLink()" 
        class="button primary" 
        [class.copied]="shareLinkCopied"
          [disabled]="shareLinkCopied || !sharePopupData.share_link">
          <img [src]="shareLinkCopied ? '../../../assets/icons/check.svg' : '../../../assets/icons/link.svg'" 
          alt="Copy"
            class="copy-button-icon" 
            [class.link-icon]="!shareLinkCopied"
             [class.check-icon]="shareLinkCopied">
            {{ (shareLinkCopied ? 'SHARE_LINK_POPUP_COPIED_BUTTON' : 'SHARE_LINK_POPUP_COPY_BUTTON') | translate }}            </button>
      </div>
    </div>
    <div class="popup-footer">
    </div>
  </div>
</div>

<!-- Streaming Confirmation Popup -->
<app-streaming-confirmation-popup 
[show]="(agentOrchestrator.showStreamingConfirmationPopup$ | async) || false"
  [options]="{
    title: ('NEW_CHAT_STREAMING_POPUP_TITLE' | translate),
    message: agentOrchestrator.getStreamingConfirmationType() === 'session_switch' 
      ? ('SESSION_SWITCH_STREAMING_POPUP_CONTENT' | translate)
      : agentOrchestrator.getStreamingConfirmationType() === 'chatbot_switch'
      ? ('CHATBOT_SWITCH_STREAMING_POPUP_CONTENT' | translate)
      : ('NEW_CHAT_STREAMING_POPUP_CONTENT_AGENT' | translate),
    confirmText: ('CONFIRM_BUTTON_TEXT' | translate),
    cancelText: ('CANCEL_BUTTON' | translate)
  }"
  (confirm)="agentOrchestrator.confirmStreamingAction()" 
  (cancel)="agentOrchestrator.cancelStreamingAction()">
</app-streaming-confirmation-popup>

